import React, { useEffect, useState } from "react";
import { TempTestPage } from "./TempTestPage";
import HelmetMetaTag from "./Components/HelmetMetaTag";
import LazyLoadingImg from "./Components/LazyLoadingImg";
import NewHomePortfolioComponent from "./Components/NewHomePortfolioComponent";
import IndustriesPortfolio from "./Components/IndustriesPortfolio";
import MoreProjectsPortfolio from "./Components/MoreProjectsPortfolio";
import Popups from "./Modals/Popups";
import PersonalizedActionModal from "./Modals/PersonalizedActionModal";
import ContactUsButton from "./Components/ContactUsButton/Index";
import FreeConsultButton from "./Components/FreeConsultButton/Index";
import FlipCard from "./Components/FlipCard";
import useWindowWidth from "../hooks/useWindowWidth";

export function NewPortfolio() {
  const width = useWindowWidth();
  const [show, setShow] = useState(false);
  var techonologiesName = [
    {
      Technology: "Frontend",
    },
    {
      Technology: "Backend",
    },
    {
      Technology: "Mobile",
    },
    {
      Technology: "UI/UX",
    },
    {
      Technology: "SEO",
    },
    {
      Technology: "Payment Gateway & API",
    },
  ];
  var techonologiesContent = [
    {
      Frontend: [
        {
          Technology: "React.js",
          Img: "/images/Technology/frontendlogo1.png",
          alt: "React logo",
          title: "Frontend Technology React ",
        },
        {
          Technology: "Vue.js",
          Img: "/images/Technology/frontendlogo2.png",
          alt: "Vue.js logo",
          title: "Frontend Technology Vue.js",
        },
        {
          Technology: "Next.js",
          Img: "/images/Technology/frontendlogo3.png",
          alt: "Next.js logo",
          title: "Frontend Technology Next.js",
        },
        {
          Technology: "Angular",
          Img: "/images/Technology/frontendlogo4.png",
          alt: "Angular logo",
          title: "Frontend Technology Angular",
        },
        {
          Technology: "Html",
          Img: "/images/Technology/frontendlogo5.png",
          alt: "Html logo",
          title: "Frontend Technology Html",
        },
        {
          Technology: "Css",
          Img: "/images/Technology/frontendlogo6.png",
          alt: "CSS logo",
          title: "Frontend Technology CSS",
        },
        {
          Technology: "Bootstrap",
          Img: "/images/Technology/frontendlogo7.png",
          alt: "BootStrap logo",
          title: "Frontend Technology BootStrap",
        },
      ],
      Backend: [
        {
          Technology: "Asp.net core",
          Img: "/images/Technology/backendlogo1.png",
          alt: "Asp.net core logo  ",
          title: "Backend Technology Asp.net core ",
        },
        {
          Technology: "Asp.net MVC",
          Img: "/images/Technology/backendlogo2.png",
          alt: "Asp.net MVC logo",
          title: "Backend Technology Asp.net MVC ",
        },
        {
          Technology: "Node.js",
          Img: "/images/Technology/backendlogo3.png",
          alt: "Node.js logo",
          title: "Backend Technology Node.js",
        },
        {
          Technology: "Express",
          Img: "/images/Technology/Express.png",
          alt: "Express",
          title: "Backend Technology Express",
        },
        {
          Technology: "Php",
          Img: "/images/Technology/backendlogo4.png",
          alt: "Php logo",
          title: "Backend Technology Php",
        },
        {
          Technology: "Laravel",
          Img: "/images/Technology/backendlogo5.png",
          alt: "Laravel logo",
          title: "Backend Technology Laravel",
        },
        {
          Technology: "Code Igniter",
          Img: "/images/Technology/backendlogo6.png",
          alt: "Code Igniter logo",
          title: "Backend Technology Code Igniter",
        },
      ],
      CMS: [
        {
          Technology: "IOS",
          Img: "/images/Technology/mobile1.png",
          alt: "IOS",
          title: "IOS",
        },
        {
          Technology: "Android",
          Img: "/images/Technology/mobile2.png",
          alt: "Android",
          title: "Android",
        },
        {
          Technology: "Swift",
          Img: "/images/Technology/mobile3.png",
          alt: "Swift ",
          title: "Swift ",
        },
        {
          Technology: "Flutter",
          Img: "/images/Technology/mobile4.png",
          alt: "Flutter",
          title: "Flutter",
        },
        {
          Technology: "React Native",
          Img: "/images/Technology/mobile5.png",
          alt: "React Native",
          title: "React Native",
        },
        {
          Technology: "JavaScript",
          Img: "/images/Technology/mobile6.png",
          alt: "Java Script",
          title: "Java Script",
        },
        {
          Technology: "Kotlin",
          Img: "/images/Technology/mobile7.png",
          alt: "Kotlin",
          title: "Kotlin",
        },
      ],
      DataBases: [
        {
          Technology: "Figma",
          Img: "/images/Technology/figma.png",
          alt: "Figma",
          title: "Technology Figma",
        },
        {
          Technology: "Adobe XD",
          Img: "/images/Technology/AdobeXD.png",
          alt: "Adobe XD",
          title: "Technology Adobe XD",
        },
        {
          Technology: "Adobe Photoshop",
          Img: "/images/Technology/PhotoShop.png",
          alt: "Adobe Photoshop",
          title: "Technology Adobe Photoshop",
        },
        {
          Technology: "Adobe illustrator",
          Img: "/images/Technology/illustrator.png",
          alt: "Adobe illustrator",
          title: "Technology Adobe illustrator",
        },
        {
          Technology: "Adobe Premierpro",
          Img: "/images/Technology/Premierpro.png",
          alt: "Adobe Premiere Pro",
          title: "Technology Adobe Premiere Pro",
        },
        {
          Technology: "Adobe After Effect",
          Img: "/images/Technology/AdobeAfterEffect.png",
          alt: "Adobe After Effect",
          title: "Technology Adobe After Effect",
        },
      ],
      CloudServices: [
        {
          Technology: "Google Analytics",
          Img: "/images/Technology/SeoTools1.svg",
          alt: "Google Analytics",
          title: "Google Analytics",
        },
        {
          Technology: "Google Console",
          Img: "/images/Technology/SeoTools2.svg",
          alt: "Google Console",
          title: "Google Console",
        },
        {
          Technology: "Google Ads",
          Img: "/images/Technology/SeoTools3.svg",
          alt: "Google Adwords",
          title: "Google Adwords",
        },
        {
          Technology: "Aherfs",
          Img: "/images/Technology/SeoTools4.svg",
          alt: "Aherfs",
          title: "Aherfs",
        },
        {
          Technology: "Semrush",
          Img: "/images/Technology/SeoTools5.svg",
          alt: "Semrush",
          title: "Semrush",
        },
        {
          Technology: "Moz",
          Img: "/images/Technology/SeoTools6.svg",
          alt: "Moz",
          title: "Moz",
        },
        {
          Technology: "Sitebulb",
          Img: "/images/Technology/SeoTools7.svg",
          alt: "Sitebulb",
          title: "Sitebulb",
        },
        {
          Technology: "Screaming Frog",
          Img: "/images/Technology/frog.svg",
          alt: "Screaming Frog",
          title: "Screaming Frog",
        },
      ],
      ThirdPartyServices: [
        {
          Technology: "Stripe",
          Img: "/images/Technology/stripe.png",
          alt: "Stripe",
          title: "Stripe",
        },
        {
          Technology: "Twilio",
          Img: "/images/Technology/twilio.png",
          alt: "Twilio",
          title: "Twilio",
        },
        {
          Technology: "RazorPay",
          Img: "/images/Technology/RazorPay.png",
          alt: "RazorPay",
          title: "RazorPay",
        },
        {
          Technology: "Webhooks",
          Img: "/images/Technology/webhooks.png",
          alt: "Webhooks",
          title: "Webhooks",
        },
        {
          Technology: "Zendesk",
          Img: "/images/ZendeskApi.svg",
          alt: "Zendesk",
          title: "Zendesk",
        },
        {
          Technology: "Zapier",
          Img: "/images/ZaiperApi.svg",
          alt: "Zapier",
          title: "Zapier",
        },
        {
          Technology: "Freshbooks",
          Img: "/images/FreshBooksApi.svg",
          alt: "Freshbooks",
          title: "Freshbooks",
        },
        {
          Technology: "SendGrid",
          Img: "/images/SendGridApi.svg",
          alt: "SendGrid",
          title: "SendGrid",
        },
      ],
    },
  ];

  return (
    <>
      <HelmetMetaTag
        titleName="Explore Our Portfolio of Innovative IT Solutions | SprigStack"
        desc="Explore SprigStack's portfolio for top-notch web development and design projects, showcasing our expertise in frontend, backend, mobile, UI/UX, and SEO."
        canonical="https://sprigstack.com/portfolio"
        ogtitle="Explore Our Portfolio of Innovative IT Solutions | SprigStack"
        ogdesc="Explore SprigStack's portfolio for top-notch web development and design projects, showcasing our expertise in frontend, backend, mobile, UI/UX, and SEO."
        ogtype="website"
        ogurl="https://sprigstack.com/portfolio"
      />
      <div className="pb-5 position-relative">
        <div className="fit-background-container">
          <LazyLoadingImg
            src="/images/Portfolio_Header_Background.png"
            alt="Portfolio"
            title="Portfolio_background"
            className="fit-background-image"
          />
        </div>
        <div className="container-fluid px-0 ">
          <div className="row px-lg-6 px-sm-6 pe-md-0">
            <div className="col-lg-6 col-md-6 col-12 py-3 px-md-3 px-0 ps-lg-2 align-content-center position-relative">
              <span className="background-color-1"></span>
              {/* <span className="request-demo" onClick={() => setShow(true)}>
                Request Demo
              </span> */}
              <div className="main-title-style mt-lg-2 mt-3">
                <h1>
                  <span>Our </span>
                  {width >= 736 && <br />}
                  <span className="position-relative">
                    Creative
                    {width >= 736 && (
                      <img
                        src="/images/main-pic-1.png"
                        alt="Portfolio"
                        title="Portfolio_background"
                        className="main-pic-1-style img-fluid"
                      />
                    )}
                  </span>
                  <div className="position-relative">
                    Portfolio
                    {width >= 1120 && (
                      <img
                        src="/images/main-pic-2.png"
                        alt="Portfolio"
                        title="Portfolio_background"
                        className="main-pic-2-style img-fluid"
                      />
                    )}
                  </div>
                </h1>
              </div>
              <div
                className="row mb-2 C_font2 me-md-5 pe-md-5 py-2 ps-md-0 mx-0"
                style={{ textAlign: "justify" }}
              >
                Our proficiency in technology allows us to design custom
                solutions that cater to the unique needs of our clients.
              </div>
              <div className="" onClick={() => setShow(true)}>
                <ContactUsButton />
                {/* <button
                  className="contact-us-btn"
                 
                >
                  Contact with us
                </button> */}
              </div>
              <div className="col-12 mt-4" style={{ display: "flex" }}>
                <a
                  href="https://www.upwork.com/ag/sprigstack/"
                  rel="nofollow"
                  target="_blank"
                >
                  <img
                    src="/images/Upwork-Black-Logo.svg"
                    className="img-fluid pe-md-5 pe-3 crsr-pointer"
                    alt="Upwork icon"
                    title="Upwork Sprigstack Profile"
                  />
                </a>
                <a
                  href="https://www.behance.net/sprigstack"
                  rel="nofollow"
                  target="_blank"
                >
                  <img
                    src="/images/BehanceLogo.svg"
                    className="img-fluid  pe-md-5 pe-3  crsr-pointer"
                    alt="Behance icon"
                    title="Behance SprigStack Profile"
                  />
                </a>
                <a
                  href="https://clutch.co/profile/sprigstack"
                  rel="nofollow"
                  target="_blank"
                >
                  <img
                    src="/images/Clutch-Black.svg"
                    className="img-fluid  pe-md-5 pe-3 crsr-pointer"
                    alt="Clutch icon"
                    title="Clutch SprigStack Profile"
                  />
                </a>
                <a
                  href="https://www.designrush.com/agency/profile/sprigstack"
                  rel="nofollow"
                  target="_blank"
                >
                  <img
                    src="/images/Designrush-Black.svg"
                    className="img-fluid  pe-md-5 pe-3  crsr-pointer mt-1"
                    alt="Designrush icon"
                    title="Designrush SprigStack Profile"
                  />
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 homePageGYB  py-lg-4 ps-3 pe-0 mt-md-0 mt-3">
              <LazyLoadingImg
                src={`/images/portfolio-header-image${
                  width <= 768 ? "-mobile" : ""
                }.png`}
                alt="Portfolio"
                title="Portfolio_header_image"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
        <NewHomePortfolioComponent
          ImagePosition="image-pos-right new-portfolio-card divHoverEffect"
          mainClass="horizontal-padding"
          PortfolioCardBGC="#f3f3f3"
          title="Euroriente - ERP System for the Travel Industry"
          titleClass="new-portfolio-title"
          borderColor="#EFF2FF"
          customSectionCol="col-lg-8 col-md-8 col-12"
          customSection1Col="col-lg-6 col-md-6 col-6"
          customSection2Col="col-lg-6 col-md-6 col-6"
          customSection2ColPadding="1.8rem"
          sectionOneTextOne="100K+"
          sectionOneTextTwo="Tour Package Bookings"
          imgSrc="NewEurorientePortfolioImg.webp"
          sectionTextColor="portfolio-sectionTextColor"
          linkTitle="frontendlogo1.png,backendlogo1.png,database4.png,frontendlogo7.png,CloudService1.png,stripe.png,twilio.png"
          TitleCustomClasses=""
          portfolioBtn={true}
          portfolioBtnColor={"#8698ED"}
          cardClass="left-portfolio-card bg-white"
          IndustryServingsHoverCompimgSrc="images/Vector (2).png"
          IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
          customLineHeight="45px"
          customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
          IsRedirectToSamePage="no"
          redirectNumber="/portfolio/development-of-an-erp-system-for-the-travel-industry"
        />
        <NewHomePortfolioComponent
          ImagePosition="new-portfolio-card divHoverEffect"
          mainClass="horizontal-padding"
          PortfolioCardBGC="#fff"
          title="K-12 : Web Based Solution for the Ed-Tech Industry"
          titleClass="new-portfolio-title"
          borderColor="rgb(234, 245, 255)"
          customSectionCol="col-lg-8 col-md-8 col-12"
          customSection1Col="col-lg-6 col-md-6 col-6"
          customSection2Col="col-lg-6 col-md-6 col-6"
          customSection2ColPadding="1.8rem"
          sectionOneTextOne="1000+"
          sectionOneTextTwo="Device's Repaired"
          imgSrc="new-K12-mockup.webp"
          sectionTextColor="cl3CBBA5"
          linkTitle="backendlogo5.png, frontendlogo1.png, frontendlogo7.png, database2.png, CloudService1.png, fedex.png"
          TitleCustomClasses="fontColorBlue"
          portfolioBtn={true}
          portfolioBtnColor={"#3CBCA5"}
          cardClass="p-md-5 newportpadding bg-white"
          IndustryServingsHoverCompimgSrc="images/Vector (2).png"
          IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
          customLineHeight="45px"
          customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
          IsRedirectToSamePage="no"
          redirectNumber="/portfolio/website-development-for-K12"
        />
        <NewHomePortfolioComponent
          ImagePosition="image-pos-right new-portfolio-card divHoverEffect"
          mainClass="horizontal-padding"
          PortfolioCardBGC="rgb(239, 242, 255)"
          title="AddressTwo - Small Business CRM"
          titleClass="new-portfolio-title"
          borderColor="rgb(32,63,89)"
          customSectionCol="col-lg-8 col-md-8 col-12"
          customSection1Col="col-lg-6 col-md-6 col-6"
          customSection2Col="col-lg-6 col-md-6 col-6"
          customSection2ColPadding="1.8rem"
          sectionOneTextOne="5M+"
          sectionOneTextTwo="Daily Emails Delivered"
          sectionTwoTextOne="100+"
          sectionTwoTextTwo="Monthly New Signups"
          imgSrc="NewAddressTwoMockup.webp"
          sectionTextColor="fontColorBlue"
          linkTitle="frontendlogo1.png, database1.png, backendlogo2.png, frontendlogo7.png"
          TitleCustomClasses="fontColorBlue"
          portfolioBtn={true}
          portfolioBtnColor={"#8698ED"}
          cardClass="left-portfolio-card bg-white"
          IndustryServingsHoverCompimgSrc="images/Vector (2).png"
          IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
          redirectNumber="/portfolio/custom-crm-development-for-address-two"
          customLineHeight="34px"
          customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
        />
        <NewHomePortfolioComponent
          ImagePosition="new-portfolio-card divHoverEffect"
          mainClass="horizontal-padding"
          PortfolioCardBGC="#fff"
          title="Cricbuddy - Sports Venue Booking"
          titleClass="new-portfolio-title"
          borderColor="rgb(234, 245, 255)"
          customSectionCol="col-lg-8 col-md-8 col-12"
          customSection1Col="col-lg-6 col-md-6 col-6"
          customSection2Col="col-lg-6 col-md-6 col-6"
          customSection2ColPadding="1.8rem"
          sectionOneTextOne="10000+"
          sectionOneTextTwo="Bookings"
          imgSrc="cricbuddy-portfolio.webp"
          sectionTextColor="cl3CBBA5"
          linkTitle="frontendlogo1.png, frontendlogo5.png, frontendlogo6.png, backendlogo1.png, backendlogo3.png, database1.png, Express.png, SignalR.png, Gupshup.png, RazorPay.png, witAi.png"
          TitleCustomClasses="fontColorBlue"
          portfolioBtn={true}
          portfolioBtnColor={"#2A2B26"}
          cardClass="p-md-5 newportpadding bg-white"
          IndustryServingsHoverCompimgSrc="images/Vector (2).png"
          IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
          customLineHeight="45px"
          customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
          IsRedirectToSamePage="no"
          redirectNumber="/portfolio/mobile-app-development-for-sports-venue-booking"
        />
        <NewHomePortfolioComponent
          ImagePosition="image-pos-right new-portfolio-card divHoverEffect"
          mainClass="horizontal-padding"
          PortfolioCardBGC="#FCF1F2"
          title="MPC - Pet Food E-Commerce With Automated Delivery System"
          titleClass="new-portfolio-title"
          borderColor="#00671c"
          customSectionCol="col-lg-8 col-md-8 col-12"
          customSection1Col="col-lg-6 col-md-6 col-6"
          customSection2Col="col-lg-6 col-md-6 col-6"
          customSection2ColPadding="1.8rem"
          sectionOneTextOne="10000+"
          sectionOneTextTwo="Happy Customers"
          sectionTwoTextOne="500+"
          sectionTwoTextTwo="Daily Orders"
          imgSrc="new-mpc-portfolio.webp"
          sectionTextColor="clB60117"
          linkTitle="frontendlogo7.png, database2.png, backendlogo5.png, webhooks.png, cms2.png"
          TitleCustomClasses="fontColorBlue"
          portfolioBtn={true}
          portfolioBtnColor={"#F64646"}
          cardClass="left-portfolio-card bg-white"
          IndustryServingsHoverCompimgSrc="images/Vector (2).png"
          IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
          customLineHeight="45px"
          customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
          IsRedirectToSamePage="no"
          redirectNumber="/portfolio/ecommerce-website-development-for-my-pet-carnivore"
        />
        <NewHomePortfolioComponent
          ImagePosition="new-portfolio-card divHoverEffect"
          mainClass="horizontal-padding"
          PortfolioCardBGC="#fff"
          title="SuperBuildup - Real Estate ERP Software"
          titleClass="new-portfolio-title"
          borderColor="rgb(234, 245, 255)"
          customSectionCol="col-lg-8 col-md-8 col-12"
          customSection1Col="col-lg-6 col-md-6 col-6"
          customSection2Col="col-lg-6 col-md-6 col-6"
          customSection2ColPadding="1.8rem"
          sectionOneTextOne="100K+"
          sectionOneTextTwo="Projects"
          imgSrc="superBuildUp.webp"
          sectionTextColor="cl3CBBA5"
          linkTitle="frontendlogo1.png, database2.png,backendlogo5.png,frontendlogo7.png, Whatsapp.png, SMTP.png"
          TitleCustomClasses="fontColorBlue"
          portfolioBtn={true}
          portfolioBtnColor={"#2A2B26"}
          cardClass="p-md-5 newportpadding bg-white"
          IndustryServingsHoverCompimgSrc="images/Vector (2).png"
          IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
          customLineHeight="45px"
          customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
          IsRedirectToSamePage="no"
          redirectNumber="/portfolio/development-of-an-erp-system-for-the-real-estate-industry"
        />
        <NewHomePortfolioComponent
          ImagePosition="image-pos-right new-portfolio-card divHoverEffect"
          mainClass="horizontal-padding"
          PortfolioCardBGC="#FCF1F2"
          title="PatientCure : Complete care. Anytime. Anywhere."
          titleClass="new-portfolio-title"
          borderColor="rgb(234, 245, 255)"
          customSectionCol="col-lg-8 col-md-8 col-12"
          customSection1Col="col-lg-6 col-md-6 col-6"
          customSection2Col="col-lg-6 col-md-6 col-6"
          customSection2ColPadding="1.8rem"
          sectionOneTextOne="100K+"
          sectionOneTextTwo="Patience Cured"
          imgSrc="k12WebSolution-portfolio.png"
          sectionTextColor="cl3CBBA5"
          linkTitle="frontendlogo1.png, database1.png,backendlogo5.png,frontendlogo7.png,CloudService1.png,fedex.png"
          TitleCustomClasses="fontColorBlue"
          portfolioBtn={false}
          portfolioBtnColor={"#2A2B26"}
          cardClass="p-md-5 newportpadding bg-white"
          IndustryServingsHoverCompimgSrc="images/Vector (2).png"
          IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
          customLineHeight="45px"
          customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
          IsRedirectToSamePage="no"
          redirectNumber="/portfolio/website-development-for-K12"
        />

        <div className="horizontal-padding mb-lg-5 pb-lg-5">
          <h2 className="clr0E2B3D headerFontSizeH6 text-center">
            Few more projects
          </h2>
          <MoreProjectsPortfolio />
        </div>
        <div className="horizontal-padding mt-lg-5">
          <div className="row bg-orange ps-md-5 mx-0">
            <div className="col-md-6 col-12 px-5 py-5 my-md-5 my-3">
              <h2
                style={{ color: "white", fontSize: "40px", fontWeight: "900" }}
              >
                Ready to turn your idea into reality?
              </h2>
              <div className="mt-5" style={{ color: "white" }}>
                Let's get started!
              </div>
              <div
                className="mt-3"
                onClick={() => {
                  setShow(true);
                }}
              >
                <FreeConsultButton />
              </div>
            </div>
            {width >= 900 && (
              <div className="col-6 position-relative my-5">
                <div className="row">
                  <div className="col-5">
                    <FlipCard
                      dir="rtl"
                      imgArray={[
                        "/images/portfolio-cta-pic-1.png",
                        "/images/portfolio-cta-pic-2.png",
                      ]}
                    />
                  </div>
                  <div className="col-5 pt-5 mt-5">
                    {" "}
                    <FlipCard
                      imgArray={[
                        "/images/portfolio-cta-pic-3.png",
                        "/images/portfolio-cta-pic-4.png",
                      ]}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="mt-md-4 mt-0">
          <TempTestPage
            TechName={techonologiesName}
            TechContent={techonologiesContent}
            mainheader="Technologies that we expertise!"
            HeaderPadding="porttechHeading"
            SubHeaderCss="porttechSubHeading"
            flag={true}
            subHeader="Top Technologies for Developing High-Quality Websites & Web Apps."
          />
        </div>

        <IndustriesPortfolio />
      </div>
      <Popups show={show} setShow={setShow} title="FREE CONSULTATION" size="lg">
        <PersonalizedActionModal />
      </Popups>
    </>
  );
}
